import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import NavbarButton from '../components/NavbarButtonMC';
import TitleMC from '../components/TitleMC';
import SearchComponent from '../components/SearchMC';

// Height offset: header only (40px) - help bar space is handled by CSS padding
const HEADER_HEIGHT = '40px';

const StaticNavbar = ({
  children,
  className = '',
  navbarClassName = '',
  routes = [],
  currentRoute = '',
  title = '',
  fillParent = false
}) => {
  const [filteredRoutes, setFilteredRoutes] = useState(routes);
  const { t } = useTranslation();

  useEffect(() => {
    setFilteredRoutes(routes);
  }, [routes]);

  const onSearchRoute = (searchValue) => {
    const fRoutes = routes.map((route) => {
      const { subRoutes = [], ...rest } = route;
      const filteredSubRoutes = subRoutes.filter((subRoute) => {
        const { routeProps } = subRoute;
        return routeProps?.title.toLowerCase().includes(searchValue.toLowerCase());
      });
      return {
        ...rest,
        subRoutes: filteredSubRoutes
      };
    });
    setFilteredRoutes(fRoutes);
  };

  const rowClassName = fillParent
    ? 'tw-flex tw-h-full tw-min-h-0 tw-flex-row'
    : 'tw-flex tw-flex-row';

  const contentClassName = fillParent
    ? 'tw-flex-1 tw-min-h-0 tw-overflow-hidden tw-bg-white tw-flex tw-flex-col'
    : 'tw-flex-1 tw-overflow-auto tw-bg-white tw-flex tw-flex-col';

  return (
    <div className={`tw-wrapper ${fillParent ? 'tw-h-full' : ''}`}>
      <div
        className={rowClassName}
        style={fillParent ? undefined : { height: `calc(100vh - ${HEADER_HEIGHT})` }}
      >
        <div className="tw-flex-col tw-h-full">
          <div className={`lg:tw-ml-14 tw-flex tw-h-full tw-w-[250px] tw-flex-col tw-gap-3 tw-overflow-y-auto tw-border-r tw-border-gray-200 tw-bg-white tw-px-3 tw-pt-6 ${navbarClassName}`}>
            {title && (
              <TitleMC text={title} textClassName="tw-text-sm tw-font-bold" />
            )}
            <SearchComponent
              placeholder={t('staticNavbar.placeholder')}
              onChange={onSearchRoute}
              debounceTime={50}
            />
            <nav className="tw-flex-1 -tw-ml-4">
              {filteredRoutes?.map((route) => {
                const {
                  icon,
                  useCssIcon,
                  routeProps = {},
                  subRoutes = []
                } = route;
                return (
                  <NavbarButton
                    key={routeProps?.key}
                    icon={icon}
                    useCssIcon={useCssIcon}
                    routeProps={routeProps}
                    currentRoute={{ key: currentRoute }}
                    subRoutes={subRoutes}
                    opened
                  />
                );
              })}
            </nav>
          </div>
        </div>
        <div className={`${contentClassName} ${className}`}>
          {children}
        </div>
      </div>
    </div>
  );
};

export default StaticNavbar;
